import React, { useState } from "react";

const ApplicationProcedureEP = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Application Procedure",
      content: `1. Complete the online application form, providing all requested information.

2. Submit a current resume or curriculum vitae (CV), detailing relevant education, work experience, & extracurricular activities.

3. Write a personal statement (300-500 words) outlining your interest in the program, your career goals, & how you believe this course will contribute to your professional development.

4. Provide contact information for one academic or professional reference who can speak to your qualifications & potential for success in the program.

5. Pay the application fee (if applicable) & submit all materials by the specified deadline.`,
    },
    {
      id: 2,
      title: "Programme Cost",
      content: `The course fee for the Young Emerging Politician Course (15 credits) is €650. This includes tuition, course materials, & access to online resources. Please contact [insert contact information] for more details on scholarship opportunities & payment plans.
      
      Pay the full programme €650 fee upfront and receive exclusive access to a leadership webinar
with an international expert OR Pay the programme fee in instalments of €325 Bi-Monthly Payments (2 Instalments).
      `,
    },
  ];

  return (
    <div
      className="md:scroll-mt-44 scroll-mt-16 my-10"
      id="application-procedure"
    >
      <div className="bg-gradient-to-r from-gray-600 to-blue-950 py-10">
        <div className="max-w-6xl mx-auto px-10 space-y-8">
          <h2 className="text-2xl font-extrabold text-center mb-6 text-white">
            Application Procedure & Programme Cost
          </h2>
          <div className="bg-sdbodywhiteywhitebodyywhitebody h-1 w-20 mx-auto rounded"></div>
          <div className="space-y-4">
            {sections.map((section) => (
              <div
                key={section.id}
                className="border border-gray-300 rounded-lg overflow-hidden shadow-lg"
              >
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-4 px-5 bg-blue-100 hover:bg-blue-200 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-lg text-gray-700">
                      {section.title}
                    </span>
                    <span className="text-gray-600">
                      {activeSection === section.id ? "▲" : "▼"}
                    </span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-5 py-4 bg-sdbodywhiteywhitebodyywhitebodyywhitebodyywhitebody">
                    <p className="text-gray-800 leading-relaxed whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProcedureEP;
